angular.module('salesPath2')
.controller('suggestedSumInsuredModalCtrl', ['$scope', '$sce', 'suggestedSumInsuredHelper', 'actionHelper', 'fireBurglaryHelper',
  function($scope, $sce, suggestedSumInsuredHelper, actionHelper, fireBurglaryHelper) {
    $scope.tplData = suggestedSumInsuredHelper.tplData;

    /**
    * init
    */
    $scope.init = function() {        
      suggestedSumInsuredHelper.setSumInsured();        
      fireBurglaryHelper.refreshLocalizationData();
      actionHelper.runAction('saveApplication');
      $scope.fireListeners();
    };

    /**
     * Odpalenie watchy
     */
    $scope.fireListeners = function() {
      // ok
      $scope.$on('iHestiaCommonModalOkBtnClicked.suggestedSumInsuredModal', function() {
      });
    };

    $scope.init();

  }
]);